import {Box, CustomCard, TitleComponent } from "ui-components";

const UnderDevelopment = () => {
  return (
    <CustomCard padding="50px" className="w-700 m-auto">
      <Box justify="center">
        <TitleComponent fontSize="50px" className="text-center">
          {"</>"}
          <br /> Under Development
        </TitleComponent>
      </Box>
    </CustomCard>
  );
};
export default UnderDevelopment;
